import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Subscription} from 'rxjs';
import {HTMLInputEvent, User, Role, Permission} from 'jugacu-lib';
import {WhistlerAPIService} from '../../../whistler-api.service';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit, OnDestroy {

    private route$: Subscription;
    public hide = true;
    public loading = true;
    public uploading = false;
    public user: User = {
        desc: '',
        email: '',
        avatar: '',
        name: '',
        nsfw: false,
        roles: [],
        permissions: [],
        password: ''
    };

    public saving = false;
    rolesReady = true;
    permissionsReady = true;

    constructor(
        private readonly whistlerAPIService: WhistlerAPIService,
        private route: ActivatedRoute,
        private snackBar: MatSnackBar
    ) {
    }

    async ngOnInit() {

        this.route$ = this.route.params.subscribe(async params => {
            try {
                const response = await this.whistlerAPIService.getRequestedUser(params.name);
                this.user = response.data;
            } catch (e) {

            } finally {
                this.loading = false;
            }
        });
    }

    ngOnDestroy(): void {
        this.route$.unsubscribe();
    }

    async saveUser() {
        try {
            this.saving = true;
            const response = await this.whistlerAPIService.saveUser(this.user);
            this.user = {
                ...this.user,
                ...response.data
            };
            this.user.password = '';
            this.snackBar.open('Saved.', 'Ok', {duration: 5000});
        } catch (e) {
            this.snackBar.open('An error has occurred, please try again later.', 'Ok', {duration: 5000});
        } finally {
            this.saving = false;
        }
    }

    async onRoleRemoved(role: Role) {
        try {
            this.rolesReady = false;
            const response = await this.whistlerAPIService.removeRoleFromUser(this.user, role);
            this.user.roles = response.data;
        } catch (e) {

        } finally {
            this.rolesReady = true;
        }
    }

    async onRoleAdded(role: Role) {
        try {
            this.rolesReady = false;
            const response = await this.whistlerAPIService.addRoleToUser(this.user, role);
            this.user.roles = response.data;
        } catch (e) {

        } finally {
            this.rolesReady = true;
        }
    }

    async onPermissionAdded(permission: Permission) {
        try {
            this.permissionsReady = false;
            const response = await this.whistlerAPIService.addPermissionToUser(this.user, permission);
            this.user.permissions = response.data;
        } catch (e) {

        } finally {
            this.permissionsReady = true;
        }
    }

    async onPermissionRemoved(permission: Permission) {
        try {
            this.permissionsReady = false;
            const response = await this.whistlerAPIService.removePermissionFromUser(this.user, permission.name);
            this.user.permissions = response.data;
        } catch (e) {

        } finally {
            this.permissionsReady = true;
        }
    }

    uploadToImgur(event: MouseEvent) {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e: HTMLInputEvent) => {
            if (this.uploading) {
                return;
            }

            const file = e.target.files['0'];
            try {
                this.uploading = true;
                const response = await this.whistlerAPIService.uploadToImgur(file);
                this.user.avatar = response.data.link;
            } catch (e) {
                //
            } finally {
                this.uploading = false;
            }

        };
        input.click();
    }
}
